import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { Grid } from "@mui/material";
import VideoAnalysisDiagram from "e.sic-platform.webclient/src/pages/analysis/components/video-analysis-diagram/VideoAnalysisDiagram";
import DamagesVideoAnalysis from "e.sic-platform.webclient/src/pages/analysis/components/DamagesVideoAnalysis";
import Tools from "e.sic-platform.webclient/src/pages/analysis/components/video-analysis-diagram/tools/Tools";
import {  DamagesStorageModel } from "e.sic-platform.webclient/src/services/damage/DamagesStorage";
import { AnalysisConfidenceStorageModel } from "e.sic-platform.webclient/src/services/organization-analysis-confidence/AnalysisConfidenceStorage";
import { featureFlagsStorage } from "e.sic-platform.webclient/src/services/feature-flags/FeatureFlagsStorage";
import { Flags } from "e.sic-platform.webclient/src/generated/FeatureFlags";
import { AnalysisService } from "e.sic-platform.webclient/src/services/analysis/AnalysisService";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";


const emptyDamagesStorage = DamagesStorageModel.create({ inspectionId: 0 });
emptyDamagesStorage.mapResponse({ totalCount: 0, rows: [], header: [] });
interface IVideoAnalysisDiagramSectionProps {
  videoAnalysis: AnalysisService;
}

export default observer(function VideoAnalysisDiagramSection(props: IVideoAnalysisDiagramSectionProps) {
    const { videoAnalysis } = props;
    const [confidenceStorage] = useState(() =>
      AnalysisConfidenceStorageModel.create({ autoLoad: false }, { api })
    );
    return (
        <>
        <Grid item xs={12} sm={12} xl={8} sx = {{mt : 4}}>
          {featureFlagsStorage.isFeatureEnabled(
            Flags.Render_VA_Diagram_In_Platform
          ) && (
            <VideoAnalysisDiagram
              video={videoAnalysis?.video}
              damagesStorage={emptyDamagesStorage}
              videoAnalysis={videoAnalysis!}
              onVAFinished={videoAnalysis.onServiceFinished}
              readonly
              canAnalyze={true}
            />
          )}
          {!featureFlagsStorage.isFeatureEnabled(
            Flags.Render_VA_Diagram_In_Platform
          ) && (
            <DamagesVideoAnalysis
              video={videoAnalysis?.video}
              damagesStorage={emptyDamagesStorage}
              videoAnalysis={videoAnalysis!}
              onVAFinished={videoAnalysis.onServiceFinished}
              inspectionLocked={false}
            />
          )}
          {videoAnalysis.analysisFailed && <div style={{marginBottom: "400px"}}></div>}
        </Grid>

        <Grid item xs={12} sm={12} xl={4} className="centered">
          <div className="legends-container">
            {featureFlagsStorage.isFeatureEnabled(
              Flags.Render_VA_Diagram_In_Platform
            ) && (
              <Tools
                videoAnalysisService={videoAnalysis!}
                analysisConfidenceStorage={confidenceStorage}
              />
            )}
          </div>
        </Grid>
        </>
    );
});

